webpackJsonp([263791100135453],{

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(17);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Block = __webpack_require__(5);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _Figure = __webpack_require__(10);
	
	var _Figure2 = _interopRequireDefault(_Figure);
	
	var _SEO = __webpack_require__(37);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _clients = __webpack_require__(92);
	
	var _clients2 = _interopRequireDefault(_clients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var posts = _ref.posts,
	      transition = _ref.transition,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { style: transition ? transition.style : { opacity: 0 } },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Fabian Schultz | About' }),
	    _react2.default.createElement(_SEO2.default, {
	      postPath: '/about',
	      postNode: {
	        subtitle: 'About',
	        excerpt: 'Hello! I\u2019m a designer & developer focused on turning ideas into delightful, practical software. I\u2019m doing my best work when collaborating closely with founders, designers, and developers.',
	        cover: data.cover
	      },
	      pageSEO: true
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { cover: data.cover },
	      _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'About'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'intro' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Professional early adopter.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Open Source on default.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Indecisive about his job title.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { id: 'content' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Block2.default,
	          { pull: true, mobilePull: true },
	          _react2.default.createElement(_Figure2.default, {
	            src: _clients2.default,
	            captionLeft: true,
	            caption: 'Some of the companies I\u2019ve worked with.'
	          })
	        ),
	        _react2.default.createElement(
	          _Block2.default,
	          { align: 'right', pull: true, mobilePull: true },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Hello! I\u2019m a designer & developer focused on turning ideas into delightful, practical software. I\u2019m doing my best work when collaborating closely with founders, designers, and developers.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Recently, I was a Technology Intern at',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: '//stinkstudios.com' },
	              'Stink Studios'
	            ),
	            ' in New York City, working with brands like Google and Spotify. I\u2019m currently working towards my BA in Interface Design in Potsdam, Germany.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Before that, I freelanced as a designer/front-end developer hybrid, helping companies such as ',
	            _react2.default.createElement(
	              'a',
	              { href: '//seatgeek.com' },
	              'SeatGeek'
	            ),
	            ',',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: '//wimdu.com' },
	              'Wimdu'
	            ),
	            ', ',
	            _react2.default.createElement(
	              'a',
	              { href: '//z.cash' },
	              'Zcash'
	            ),
	            ', and',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: '//door2door.io' },
	              'door2door'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://drive.google.com/open?id=19nybcDoTKPWsYAmq5nRmx23NwqYD32er' },
	              'R\xE9sum\xE9'
	            ),
	            ' ',
	            '\xB7 ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/fabian-schultz' },
	              'LinkedIn'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/clients.7850d7eb.svg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-c3d2521c162ed1d774f1.js